import React from 'react';

interface CurrencyProps {
  value: number | null;
  decimalPrecision: number;
}

const CurrencyFormatter: React.FC<CurrencyProps> = ({
  value,
  decimalPrecision,
}) => {
  if (value === null) return null;

  const formattedValue = value.toLocaleString('en-NG', {
    minimumFractionDigits: decimalPrecision,
    maximumFractionDigits: decimalPrecision,
  });

  return <span>₦{formattedValue}</span>;
};

export default CurrencyFormatter;